import type { PlayerOnlineStatusVo, UpdatePlayerOnlineStatusData } from './playerOnlineStatusType'
import { http } from '@/utils/http'

/**
 * 查询我的陪玩在线状态
 *
 * 当前俱乐部和当前陪玩身份由登录态 token 决定，无需额外传 clubId 或 memberId。
 * 返回 onlineStatus：0-空闲，1-离线，2-忙碌。
 */
export function requestGetMyPlayerOnlineStatus() {
  return http.get<PlayerOnlineStatusVo>('/member-portal/me/profile/online-status')
}

/**
 * 切换我的陪玩在线状态
 *
 * 仅用于当前登录陪玩修改自己的在线状态。
 * 请求 onlineStatus：0-空闲，1-离线，2-忙碌。
 * 成功后以后端返回的 onlineStatus 作为最终展示状态。
 */
export function requestPutMyPlayerOnlineStatus(data: UpdatePlayerOnlineStatusData) {
  return http.put<PlayerOnlineStatusVo>('/member-portal/me/profile/online-status', data)
}
